import { Link } from "react-router-dom";

/**
 * Site-wide urgency band for the Music Giving Hope charity gala
 * (Thursday, July 16, 2026) — the acoustic benefit night before the festival.
 * Dark "red-carpet" styling so it reads as distinct from the blue promo bands.
 * Placed at the top of high-traffic pages — homepage + /tickets.
 * Delete the usages after July 16.
 *
 * "Get Tickets" links straight to the gala's OnTourHQ checkout so people can
 * buy in one click. "See auction items" deep-links to the silent-auction
 * section on the full /music-giving-hope page.
 */
const GALA_TICKETS_URL = "https://events.ontourhq.com/e/yrd-music-giving-hope/tickets";

const CharityGalaBand = () => (
  <section
    aria-label="Music Giving Hope charity gala — this Thursday, July 16"
    className="bg-yacht-charcoal border-y-4 border-yacht-yellow"
  >
    <div className="max-w-6xl mx-auto px-5 md:px-8 py-5 md:py-6 flex flex-col md:flex-row items-center justify-between gap-5 md:gap-8 text-center md:text-left">
      {/* Message */}
      <div className="flex-1">
        <p className="inline-flex items-center gap-2 text-yacht-yellow text-[11px] md:text-xs font-extrabold uppercase tracking-[0.25em] mb-2">
          <span className="w-2 h-2 rounded-full bg-yacht-yellow animate-pulse" aria-hidden />
          This Thursday · July 16 · Charity Gala
        </p>
        <p className="text-white text-lg md:text-2xl font-bold leading-snug">
          Music Giving Hope is this Thursday, July 16
        </p>
        <p className="text-white/70 text-[13px] md:text-[15px] leading-snug mt-1.5 max-w-2xl">
          The Golden Buzzer–winning Detroit Youth Choir and three Yacht Rock
          legends · open bar · hors d&apos;oeuvres · silent auction
        </p>
      </div>

      {/* Actions */}
      <div className="flex flex-col items-center gap-2.5 shrink-0">
        <a
          href={GALA_TICKETS_URL}
          className="inline-block bg-yacht-yellow text-yacht-charcoal font-bold px-9 py-3.5 rounded-full text-base md:text-lg uppercase tracking-wide hover:brightness-110 transition-all whitespace-nowrap"
          style={{ boxShadow: "0 6px 20px hsla(54, 93%, 49%, 0.4)" }}
        >
          Get Tickets
        </a>
        <Link
          to="/music-giving-hope#silent-auction"
          className="text-yacht-yellow text-sm font-semibold underline underline-offset-2 hover:brightness-110 transition-all whitespace-nowrap"
        >
          See auction items →
        </Link>
      </div>
    </div>
  </section>
);

export default CharityGalaBand;
